import { GAME_ID, REDUX_ACTIONS } from 'a/bookClub/data/constants';

import { getQuestionSet } from './curriculumSelectors';

const initialState = {
  // A list of question item Id's answered correctly in the current in-progress round
  pendingQuestionIdsCorrect: [],
};

const gameProgressReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.END_ROUND: {
      return {
        ...state,
        pendingQuestionIdsCorrect: [],
      };
    }
    case REDUX_ACTIONS.SELECT_RESPONSE_BOOK: {
      // Response only gets "correct" credit if its the users first try on this question (in tihs round)
      if (payload.isFirstAttempt && payload.isCorrect) {
        const pendingQuestionIdsCorrect = [...state.pendingQuestionIdsCorrect];
        pendingQuestionIdsCorrect.push(payload.questionId);
        return {
          ...state,
          pendingQuestionIdsCorrect,
        };
      }
      return state;
    }
    case REDUX_ACTIONS.QUICK_ROUND: {
      const questionsCorrect = payload.pass ? getQuestionSet(payload.level).questions : [];
      return {
        ...state,
        pendingQuestionIdsCorrect: questionsCorrect,
      };
    }
    default:
      return state;
  }
};

export default gameProgressReducer;
